import { render, staticRenderFns } from "./UserComponent.vue?vue&type=template&id=acc4b5e2"
import script from "./UserComponent.vue?vue&type=script&lang=js"
export * from "./UserComponent.vue?vue&type=script&lang=js"
import style0 from "./UserComponent.vue?vue&type=style&index=0&id=acc4b5e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports